module.exports = __webpack_public_path__ + "img/inside_top_bg.3b90f5d.jpg";